import React from "react";

const four0Four = () => {
  return (
    <div>
      <h3>Sorry, no page found</h3>
    </div>
  );
};

export default four0Four;
